import fetch from "@/utils/request";

import i18n from "@/locales/index";

export default {
  saveIdCardPhoto(data?: object): any {
    return fetch({
      url: "/php/api/account/save/card",
      method: "post",
      data
    });
  },

  saveIdCardInfo(data?: object): any {
    return fetch({
      url: "/php/api/account/save/cardInfo",
      method: "post",
      data
    });
  },

  savePersonalInfo(data?: object): any {
    return fetch({
      url: "/php/api/account/save/userInfo",
      method: "post",
      data
    });
  },

  saveCustomerState(data?: object): any {
    return fetch({
      url: "/php/api/account/save/customerState",
      method: "post",
      data
    });
  },

  saveExamine(data?: object): any {
    return fetch({
      url: "/php/api/account/save/examine",
      method: "post",
      data
    });
  },

  getServerList(data?: object): any {
    return fetch({
      url: "/php/api/account/server/lists",
      method: "get",
      data
    });
  },
  // 判断开过什么户
  getAccountSituation(data?: object): any {
    return fetch({
      url: "/php/api/account/situation",
      method: "get",
      data
    });
  },

  // 白名单管理
  getWhiteList(data?: object): any {
    return fetch({
      url: "/php/api/user/check_server",
      method: "get",
      data
    });
  },


  saveServerInfo(data?: object): any {
    return fetch({
      url: "/php/api/account/save/openServer",
      method: "post",
      data
    });
  },

  saveSignaturePhoto(data?: object): any {
    return fetch({
      url: "/php/api/account/save/autograph",
      method: "post",
      data
    });
  },

  verifyFaceResult(data?: object): any {
    return fetch({
      url: "/php/api/face/callback",
      method: "get",
      data,
      customLoading: true
    });
  },

  comparePhoto(data?: object): any {
    return fetch({
      timeout: 180000,
      url: "/php/api/face/alignment",
      method: "post",
      headers: {
        post: {
          "Content-Type": "multipart/form-data"
        }
      },
      data,
      loadingText: i18n.t("common.uploading_text")
    });
  },

  submitCreateAccountInfo(data?: object): any {
    return fetch({
      url: "/php/api/account/store",
      method: "post",
      data
    });
  },

  getAccountStatus(data?: object): any {
    return fetch({
      url: "/php/api/account/status",
      method: "get",
      data
    });
  },

  bindEmail(data?: object): any {
    return fetch({
      url: "/php/api/account/email",
      method: "post",
      data
    });
  },

  getAccountProgress(data?: object): any {
    return fetch({
      url: "/php/api/account/progress",
      method: "get",
      data
    });
  },

  saveFaceInfo(data?: object): any {
    return fetch({
      url: "/php/api/account/save/face",
      method: "post",
      data
    });
  },

  getFailReasonCreateAccount(data?: object): any {
    return fetch({
      url: "/php/api/account/reason/status",
      method: "get",
      data
    });
  },

  submitUserInfoModify(data?: object): any {
    return fetch({
      url: "/php/api/account/open/edit",
      method: "get",
      data
    });
  },

  uploadVideoModify(data?: object): any {
    return fetch({
      url: "/php/api/account/upload/video",
      headers: {
        post: {
          "Content-Type": "multipart/form-data"
        }
      },
      method: "post",
      data,
      loadingText: i18n.t("common.uploading_text")
    });
  },
  /**
   * 设置交易密码
   * @param data
   */
  saveTradePassword(data?: object): any {
    return fetch({
      url: "/php/api/account/save/password",
      method: "post",
      data
    });
  },

  /**
   *
   * @param data
   */
  getTaxPlaceList(data?: object): any {
    return fetch({
      url: "/php/api/account/tax/place/lists",
      method: "get",
      data
    });
  },

  /**
   * 保存住址证明
   * @param data
   */
  saveAddressProof(data?: object): any {
    return fetch({
      url: "/php/api/account/save/address",
      method: "post",
      data
    });
  },

  /**
   *保存税务居民目的地
   */
  saveResidentPlace(data?: object): any {
    return fetch({
      url: "/php/api/account/save/residentPlace",
      method: "post",
      data
    });
  },

  /**
   *保存税务居民资料
   */
  saveResidentInfo(data?: object): any {
    return fetch({
      url: "/php/api/account/save/resident",
      method: "post",
      data
    });
  },

  /**
   *保存税务居民8bin资料
   */
  save8BinInfo(data?: object): any {
    return fetch({
      url: "/php/api/account/save/taxInfo",
      method: "post",
      data
    });
  },

  /**
   * 获得开户详情信息
   */
  getOpenAccountInfo(data?: object): any {
    return fetch({
      url: "/php/api/account/info",
      method: "get",
      data
    });
  },

  //获得全部国家名称接口
  getAllCountryList(data?: object): any {
    return fetch({
      url: "/php/api/tools/get_country_lists",
      method: "get",
      data
    });
  },

  getEnum(data?: any): any {
    const { customLoading, loadingText, ...query } = data || {};
    return fetch({
      url: "/php/api/tools/enum",
      method: "get",
      data: query,
      customLoading,
      loadingText
    });
  },

  saveCompanySave(data?: object): any {
    return fetch({
      url: "/php/api/account/company/save",
      method: "post",
      data
    });
  },
  saveCompanyInfo(data?: object): any {
    return fetch({
      url: "/php/api/account/company/save_info",
      method: "post",
      data
    });
  },
  saveAccountServer(data?: object): any {
    return fetch({
      url: "/php/api/account/save/server",
      method: "post",
      data
    });
  },

  getOpenInfo(data?: object): any {
    return fetch({
      url: "/php/api/account/open/info",
      method: "get",
      data
    });
  },

  saveAccountDerivative(data?: object): any {
    return fetch({
      url: "/php/api/account/save/derivative",
      method: "post",
      data
    });
  },

  // 校验登录密码
  checkPasswordFail(data?: object): any {
    return fetch({
      url: "/php/api/account/check/loginPassword",
      method: "post",
      data
    });
  },

  //校验邮箱是否占用
  checkEmailFail(data?: object): any {
    return fetch({
      url: "/php/api/account/email/check",
      method: "post",
      data
    });
  },

  //获取账户资料
  getSupplementInfo(data?: object): any {
    return fetch({
      url: "/php/api/account/supplement/info",
      method: "get",
      data
    });
  },
  getFailInfo(data?: object): any {
    return fetch({
      url: "/php/api/account/reason/status",
      method: "get",
      data
    });
  },

  //保存修改账户资料
  saveSupplement(data?: object): any {
    return fetch({
      url: "/php/api/account/supplement/save",
      method: "post",
      data
    });
  },

  //我的待办-审核不通过-设置我知道了
  accountKnowSet(data?: object): any {
    return fetch({
      url: "/php/api/account/know/set",
      method: "post",
      data
    });
  },
  // 客户确认 提交协议
  customerCommitment(data?: object): any {
    return fetch({
      url: "/php/api/account/save/customerCommitment",
      method: "post",
      data
    });
  },
  // 修改审核不通过资料
  accountSupplementUpdate(data?: object): any {
    return fetch({
      url: "/php/api/account/supplement/update",
      method: "post",
      data
    });
  },
  // 保存推荐人
  accountSaveRecommendApi(data?: object): any {
    return fetch({
      url: "/php/api/account/save/recommendBy",
      method: "post",
      data,
      customLoading: true
    });
  },
  companySaveRecommendApi(data?: object): any {
    return fetch({
      url: "api/account/company/save/recommendBy",
      method: "post",
      data,
      customLoading: true
    });
  },
};
